import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';

@Component({
  selector: 'app-dashboarduserassessmentdetail',
  templateUrl: './dashboarduserassessmentdetail.component.html',
  styleUrls: ['./dashboarduserassessmentdetail.component.css'],
})
export class DashboarduserassessmentdetailComponent implements OnInit {
  @Input() assessment: any;
  moduleimageurl: any;

  constructor(
    private modulemanager: ModulemanagementService,
    private router: Router
  ) {}

  async ngOnInit() {
    await this.setmoduleimage();
  }
  async setmoduleimage() {
    this.moduleimageurl = (
      await this.modulemanager
        .getModuleLogoURL(this.assessment.moduleid)
        .toPromise()
    ).url;
  }
  viewAssessment(id: number, batchId: number) {
    this.router.navigate(['user/assessmentconsole'], {
      queryParams: { classid: id, batchid: batchId },
    });
  }
}
